import { render, staticRenderFns } from "./SpecialtiesMappings.vue?vue&type=template&id=f17313d4&scoped=true"
import script from "./SpecialtiesMappings.vue?vue&type=script&lang=js"
export * from "./SpecialtiesMappings.vue?vue&type=script&lang=js"
import style0 from "./SpecialtiesMappings.vue?vue&type=style&index=0&id=f17313d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17313d4",
  null
  
)

export default component.exports